import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { CustomFieldsModule } from 'src/app/components/custom-fields/custom-fields.module';
import { ResponseInputModule } from 'src/app/components/custom-fields/response-input/response-input.module';

import { CustomerAdminPageRoutingModule } from './customer-admin-routing.module';
import { CustomerAdminPage } from './customer-admin.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CustomerAdminPageRoutingModule,
    NgxTippyModule,
    ResponseInputModule,
    CustomFieldsModule,
  ],
  declarations: [CustomerAdminPage],
})
export class CustomerAdminPageModule {}
